import * as types from '../actionType'

const initialState = []

const userDeleteAddress = (state = initialState, action) => {
    switch (action.type) {
        case types.USER_DELETE_ADDRESS:
            return action.payload
        default:
            return state
    }
}


export { userDeleteAddress }